export default "__VITE_PUBLIC_ASSET__11b2ed76__"